import React from 'react';
import { useAppDispatch } from 'app/hooks';
import { addPage } from 'features/document/documentSlice';
import Button from 'components/Button/Button';
import styles from './AddPage.module.css';

interface Props {
  previousPageIndex: number;
}

const AddPage: React.FC<Props> = ({ previousPageIndex }) => {
  const dispatch = useAppDispatch();

  const handleAddSection = () => {
    dispatch(
      addPage({
        previousPageIndex,
      })
    );
  };

  return (
    <div className={styles.addPage}>
      <div className={styles.button}>
        <Button variant='primary' onClick={handleAddSection}>
          + Add Page
        </Button>
      </div>
      <div className={styles.pointLine} />
    </div>
  );
};

export default AddPage;
